import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.83325 5.55318C5.83325 4.23457 7.292 3.43817 8.40118 4.15122L15.3191 8.59844C16.3396 9.2545 16.3396 10.7463 15.3191 11.4024L8.40118 15.8496C7.292 16.5626 5.83325 15.7662 5.83325 14.4476V5.55318Z",
		fill: "currentColor"
	})
});
export default SvgPlay;
